"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const bagaddto = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-bagaddto` : '') + (description ? ` desc-bagaddto` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-bagaddto"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-bagaddto"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2221)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.4.55h.21c1.09.07 2.1.55 2.91 1.35a5.95 5.95 0 0 1 1.62 3.28.75.75 0 0 1-1.48.24 4.45 4.45 0 0 0-1.2-2.46c-.6-.6-1.33-.9-2.07-.91-.72 0-1.45.31-2.05.91-.6.6-1.04 1.46-1.2 2.44a.75.75 0 0 1-1.48-.25c.2-1.25.77-2.4 1.62-3.25A4.45 4.45 0 0 1 11.39.55Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.03 4.55a2.07 2.07 0 0 1 2.1 1.75c.02.08.02.16.01.24l-1 6.38a.75.75 0 0 1-1.48-.24l.98-6.23a.6.6 0 0 0-.2-.27.57.57 0 0 0-.38-.13H2.74a.57.57 0 0 0-.39.13.6.6 0 0 0-.19.28l1.89 13.35v.14a.59.59 0 0 0 .17.44l.09.07.1.05c.07.03.14.04.22.04h9.27a.75.75 0 0 1 0 1.5H4.68a2.02 2.02 0 0 1-2-1.33 2.4 2.4 0 0 1-.12-.75L.66 6.53a.75.75 0 0 1 0-.23 2.07 2.07 0 0 1 2.1-1.74h17.27Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.9 17.3a4.5 4.5 0 1 0-4.5 4.5v1.5a6 6 0 1 1 0-12 6 6 0 0 1 0 12v-1.5a4.5 4.5 0 0 0 4.5-4.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.9 20.3v-2.5h-2.5a.5.5 0 1 1 0-1h2.5v-2.5a.5.5 0 0 1 1 0v2.5h2.5a.5.5 0 1 1 0 1h-2.5v2.5a.5.5 0 1 1-1 0Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2221"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = bagaddto;